<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img class="logo" src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="address_tel_fax">
      <span>地址：广州市天河区中山大道建工路9-11号三楼312号</span>
      <br>
      <span>Tel：020-89280356</span>
      <span>Fax：020-89280356</span>
    </p>
    <p class="email_wx">
      <span>邮箱：hr@my2388.com</span>
    </p>
    <a class="copy" href="https://beian.miit.gov.cn">ICP主体备案号：粤ICP备19105310号</a>
    <p class="copy">Copyright &copy; 2020 - 2026 广州家家智能科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 400px;
  height: 70px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 10px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue